import {ProjectName} from "modules";
import i18next from "i18next";
import {padStart, toString} from "lodash";

const PROJECT_PATH = {
	CONTENT_BRACKET: "/content-bracket",
	DRAW_PREDICTOR: "/draw-predictor",
	TRIVIA: "/trivia",
	GAME_ZONE: "/",
};

const currentLanguage = i18next.language || "en";
const LANGUAGE_PATH = currentLanguage === "en" ? "" : "/" + currentLanguage;

export const getProjectLink = (project: ProjectName, path = "/") =>
	PROJECT_PATH[project] + LANGUAGE_PATH + path;

export const geValueWithPad = (value: string, pad: number, chars: string) => {
	return padStart(value, pad, chars);
};

export const getPadForTimer = (value: number) => geValueWithPad(toString(value), 2, "0");
